import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "table align-middle table-row-dashed fs-6 gy-5" }
const _hoisted_2 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }

import { ref } from "vue";
import SiderDetail from "@/components/SiderDetail.vue";
import SiderDetail2 from "@/components/SiderDetail2.vue";
import UserService from "../../services/UserService";
import TableFooter from "@/components/TableFooter.vue";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'walletDetail',
  setup(__props, { expose: __expose }) {

const t = useI18n().t;
const isLoading = ref(true);
const submitted = ref(false);

const walletDetailShowRef = ref<InstanceType<typeof SiderDetail>>();
const detailTitle = ref(t("fields.walletDetail"));
const walletDetail = ref(Array<any>());
const currencyId = ref(0);
const walletId = ref(0);
const period = ref([] as any);
const types = {
  System: 0,
  InternalTransfer: 200,
  Deposit: 300,
  Withdrawal: 400,
  Rebate: 500,
};

const criteria = ref({
  page: 1,
  size: 10,
  matterType: null,
  from: null,
  to: null,
} as any);

const show = (_walletId: number, _currencyId: number) => {
  walletDetailShowRef.value?.show();
  currencyId.value = _currencyId;
  walletId.value = _walletId;
  fetchData(1);
};

const fetchData = async (_page: number) => {
  isLoading.value = true;

  try {
    criteria.value.page = _page;
    const res = await UserService.getWalletTransactionByWalletId(
      walletId.value,
      criteria.value
    );
    criteria.value = res.criteria;
    walletDetail.value = res.data;
  } catch (error) {
    console.log(error);
  }
  isLoading.value = false;
};

const submit = () => {
  criteria.value.from = period.value[0].toISOString();
  criteria.value.to = period.value[1].toISOString();
  fetchData(1);
};

const reset = () => {
  criteria.value.matterType = null;
  criteria.value.from = null;
  criteria.value.to = null;
  period.value = [];
  fetchData(1);
};
const close = () => {
  walletDetailShowRef.value?.hide();
};
const getStatus = (object, value) => {
  return Object.keys(object).find((key) => object[key] === value);
};
__expose({ show });

return (_ctx: any,_cache: any) => {
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_BalanceShow = _resolveComponent("BalanceShow")!
  const _component_TimeShow = _resolveComponent("TimeShow")!

  return (_openBlock(), _createBlock(SiderDetail2, {
    save: submit,
    discard: close,
    title: detailTitle.value,
    elId: "user_detail_show",
    isLoading: isLoading.value,
    submited: submitted.value,
    isDisabled: false,
    savingTitle: _ctx.$t('action.saving'),
    "show-footer": false,
    width: "1200px",
    ref_key: "walletDetailShowRef",
    ref: walletDetailShowRef
  }, {
    default: _withCtx(() => [
      _createElementVNode("table", _hoisted_1, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", _hoisted_2, [
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.type")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.status")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.amount")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.time")), 1)
          ])
        ]),
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_3, [
              _createVNode(_component_LoadingRing)
            ]))
          : (!isLoading.value && walletDetail.value.length === 0)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_4, [
                _createVNode(_component_NoDataBox)
              ]))
            : (_openBlock(), _createElementBlock("tbody", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(walletDetail.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", null, _toDisplayString(_ctx.$t(`type.matter.${item.matter.type}`)), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.$t(`type.transactionState.${item.matter.stateId}`)), 1),
                    _createElementVNode("td", null, [
                      _createVNode(_component_BalanceShow, {
                        "currency-id": currencyId.value,
                        balance: item.amount
                      }, null, 8, ["currency-id", "balance"])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_TimeShow, {
                        "date-iso-string": item.matter.postedOn,
                        type: "inFields"
                      }, null, 8, ["date-iso-string"])
                    ])
                  ]))
                }), 128))
              ])),
        _createVNode(TableFooter, {
          onPageChange: fetchData,
          criteria: criteria.value
        }, null, 8, ["criteria"])
      ])
    ]),
    _: 1
  }, 8, ["title", "isLoading", "submited", "savingTitle"]))
}
}

})